import React from 'react';
import './Summary.css';
import image from './logoSarcevic.png';

const Summary = () => {

    return (
                <React.Fragment>
                             <div id="summary_image"><img src={image} style={{opacity:'0.7'}} alt="TPS logo"/></div>
                </React.Fragment>
       
    );
};

export default Summary;
